import React, { useEffect, useMemo, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";

// Check Auth
import { isUserLoggedIn } from "./../../../../@core/auth/utils";

// @Utility
import filterImages from "./../../../../@utility/app/filterImages";

// Redux
import { openGetCredit, openInviteFriend } from "./../../../../@core/redux/actions/affiliate/index";
import { setHomeMenuType } from "./../../../../@core/redux/actions/home/index";
import { setDataAlert } from "./../../../../@core/redux/actions/app/alert";
import { setOpenWheelStatus } from "./../../../../@core/redux/actions/app/wheel";

// Component
import ProgressiveImage from "./ProgressiveImage";

// CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const useStyles = makeStyles(() => ({
    cardCoverCamp: {
        width: "100%",
        height: "100%",
        cursor: "pointer"
    }
}));

export default function BrannerSlide({ isLargeScreen }) {
    const classes = useStyles();

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const { path } = useRouteMatch();

    const dataSetting = useSelector((state) => state.reduxAppMenu.menu_items);
    const reduxAppScrollPosition = useSelector((state) => state.reduxAppScrollPosition.top);

    const [dataList, setDataList] = useState([]);

    const settings = useMemo(
        () => ({
            infinite: Array.isArray(dataList) && dataList.length > 1,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 600,
            autoplaySpeed: 3000,
            arrows: !!isLargeScreen,
            accessibility: true
        }),
        [isLargeScreen, dataList?.length]
    );

    const openBox = useCallback(
        (page) => {
            dispatch(
                setDataAlert({
                    type: "warning",
                    title: "แจ้งเตือน",
                    text: `กรุณาเข้าสู่ระบบก่อนเข้าใช้งาน "${page}"`,
                    action: true,
                    redirect: "/login",
                    show: true,
                    buttonText: "ตกลง"
                })
            );
        },
        [dispatch]
    );

    const gotoPage = useCallback(
        (item) => {
            const page = item?.image_link;
            const typeAction = item?.image_link_type;

            if (!page) return;

            // typeAction === 4 (open modal/feature)
            if (typeAction === 4) {
                if (page === "affiliate") {
                    if (!isUserLoggedIn()) openBox("รับทรัพย์");
                    else {
                        dispatch(
                            openGetCredit({
                                tab: "affiliate",
                                show: true,
                                type: null
                            })
                        );
                    }
                    return;
                }

                if (page === "inviteFrined") {
                    if (!isUserLoggedIn()) openBox("เชิญเพื่อน");
                    else dispatch(openInviteFriend({ show: true }));
                    return;
                }

                if (page === "wheelSpin") {
                    if (!isUserLoggedIn()) openBox("กงล้อลุ้นโชค");
                    else dispatch(setOpenWheelStatus(true));
                    return;
                }

                return;
            }

            // typeAction === 3 (select camp page)
            if (typeAction === 3) {
                const menuList = dataSetting?.menu_camp || [];
                const index = menuList.findIndex((m) => m?.code === page);
                const found = index >= 0 ? menuList[index] : null;

                if (found) {
                    dispatch(
                        setHomeMenuType({
                            id: index,
                            renderPage: found.code,
                            pageTitle: found.title,
                            game_camp_image: found.game_camp_image,
                            column: {
                                desktop: found.column_desktop,
                                mobile: found.column_mobile
                            },
                            typeGame: found.game_camp_type
                        })
                    );

                    window.scrollTo({
                        top: reduxAppScrollPosition || 0,
                        left: 0,
                        behavior: "smooth"
                    });
                }
                return;
            }

            // typeAction === 1 (external link)
            if (typeAction === 1) {
                window.location.href = page;
                return;
            }

            // default: internal route
            history.push(page);
        },
        [dataSetting?.menu_camp, dispatch, history, openBox, reduxAppScrollPosition]
    );

    useEffect(() => {
        const imgs = dataSetting?.agent_image;
        if (imgs) {
            const dataImages = filterImages(imgs, "slide") || [];
            setDataList(dataImages);
        } else {
            setDataList([]);
        }
    }, [dataSetting?.agent_image]);

    // แสดงเฉพาะหน้า "/"
    const isHome = location?.pathname === "/";

    if (!isHome) return null;
    if (!dataList || dataList.length === 0) return null;

    return (
        <div id="Branner">
            <Slider {...settings}>
                {dataList.map((item) => (
                    <div key={item.id}>
                        <ProgressiveImage
                            className={classes.cardCoverCamp}
                            placeholder="/images/bluring/1000x250.jpg"
                            src={isLargeScreen ? item.image_picture : item.picture_mobile}
                            onClick={() => gotoPage(item)}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
}
